/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-square-facebook': {
    width: 43.411,
    height: 43.411,
    viewBox: '0 0 43.411 43.411',
    data:
      '<g data-name="Group 1554"><path pid="0" data-name="Path 408" d="M5.865 0h31.68a5.867 5.867 0 0 1 5.866 5.866v31.679a5.866 5.866 0 0 1-5.866 5.866H5.865a5.865 5.865 0 0 1-5.866-5.866V5.864A5.866 5.866 0 0 1 5.865-.002" _fill="#4676ed"/><path pid="1" data-name="Path 409" d="M30.252 28.096l.955-6.228h-5.976v-4.042a3.113 3.113 0 0 1 2.823-3.379 3.019 3.019 0 0 1 .688.014h2.717v-5.3a32.983 32.983 0 0 0-4.823-.421c-4.922 0-8.138 2.982-8.138 8.383v4.747h-5.471v6.228h5.47v15.056a21.771 21.771 0 0 0 6.734 0V28.096z" _fill="#fff"/></g>'
  }
})
